module.exports = __webpack_public_path__ + "media/images/mobile/products/bullet-616ed83e5f3a4f628f5582e6f6f20cb9.png";